// 质检系统
import { DICT } from '@/common/utils/dict'
import { imgRegularFn } from '@/common/utils/tool'

// 基础信息
export const baseInfo = [
  {
    title: '基础信息',
    column: [
      { label: '订单编号', prop: 'orderId' },
      { label: '揽收时间', prop: 'deliveryTime' },
      { label: '订单来源', prop: 'orderSourceName' },
      { label: '物品类型', prop: 'goodsTypeName' },
      { label: '物品名称', prop: 'goodsName' },
      { label: '产品类型', prop: 'expressTypeName' }
    ]
  },
  {
    title: '寄件信息',
    decode: true,
    column: [
      { label: '面单发放网点', prop: 'pickUpNetworkName' },
      { label: '寄件网点', prop: 'pickNetworkName' },
      { label: '寄件客户', prop: 'customerName' },
      { label: '寄件姓名', prop: 'senderName' },
      {
        label: '寄件地址',
        prop: 'senderFullAddress',
        formatter({ senderCountryName, senderProvinceName, senderCityName, senderAreaName, senderDetailedAddress, senderStreet, senderTownship }) {
          return `
          ${senderCountryName || ''}
          ${senderProvinceName || ''}
          ${senderCityName || ''}
          ${senderAreaName || ''}
          ${senderDetailedAddress || ''}
          ${senderStreet || ''}
          ${senderTownship || ''}`
        }
      },
      { label: '寄件电话', prop: 'senderMobilePhone' }
    ]
  },
  {
    title: '收件信息',
    decode: true,
    column: [
      { label: '收件网点', prop: 'dispatchNetworkName' },
      { label: '收件姓名', prop: 'receiverName' },
      {
        label: '收件地址',
        prop: 'receiverFullAddress',
        formatter({ receiverCountryName, receiverProvinceName, receiverCityName, receiverAreaName, receiverDetailedAddress, receiverStreet, receiverTownship }) {
          return `
          ${receiverCountryName || ''}
          ${receiverProvinceName || ''}
          ${receiverCityName || ''}
          ${receiverAreaName || ''}
          ${receiverDetailedAddress || ''}
          ${receiverStreet || ''}
          ${receiverTownship || ''}`
        }
      },
      { label: '收件电话', prop: 'receiverMobilePhone' }
    ]
  },
  {
    title: '结算信息',
    column: [
      { label: '计费重量', prop: 'packageTotalWeight' },
      {
        label: '长/宽/高',
        prop: 'packageSize',
        formatter({ packageLength, packageWide, packageHigh }) {
          packageLength += ''
          packageWide += ''
          packageHigh += ''
          if (isNaN(packageLength) && isNaN(packageWide) && isNaN(packageHigh)) {
            return '--'
          }
          return `${packageLength || '--'}/${packageWide || '--'}/${packageHigh || '--'}`
        }
      },
      { label: '体积重', prop: 'packageVolume' },
      { label: '结算方式', prop: 'settlementName' }
    ]
  },
  {
    title: '三段码',
    column: [
      {
        label: '一段码',
        prop: 'terminalDispatchCode1',
        formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[0] : ''
        }
      },
      {
        label: '二段码',
        prop: 'terminalDispatchCode2',
        formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[1] : ''
        }
      },
      {
        label: '三段码',
        prop: 'terminalDispatchCode3',
        formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[2] : ''
        }
      }
    ]
  },
  {
    title: '其他信息',
    column: [
      {
        label: '退件标识',
        prop: 'isRefund',
        formatter: ({ isRefund }) => {
          const labels = ['否', '是', '已转件', '转退件']
          return labels[isRefund]
        }
      },
      {
        label: '签收标识',
        prop: 'isSign',
        formatter: ({ isSign }) => {
          const labels = ['否', '正常签收', '退件签收']
          return labels[isSign]
        }
      },
      { label: '回单编号', prop: 'receiptNo' },
      {
        label: '问题标识',
        prop: 'isAbnormal',
        formatter: ({ isAbnormal }) => {
          const labels = ['否', '是']
          return labels[isAbnormal]
        }
      },
      {
        label: '作废标识',
        prop: 'isVoid',
        formatter: ({ isVoid }) => {
          const labels = ['否', '是']
          return labels[isVoid]
        }
      }
    ]
  }
]
// 基础信息
export const baseInfoTable = {
  width: '800px',
  head: [
    {
      label: '寄件网点',
      prop: 'pickNetworkName'
    },
    {
      label: '寄件人电话',
      prop: 'senderMobilePhone',
      style: { width: '120px' },
      decode: true
    },
    {
      label: '寄件地址',
      prop: 'senderFullAddress',
      style: { width: '20%' },
      formatter({ senderCountryName, senderProvinceName, senderCityName, senderAreaName, senderDetailedAddress, senderStreet, senderTownship }) {
        return `
        ${senderCountryName || ''}
        ${senderProvinceName || ''}
        ${senderCityName || ''}
        ${senderAreaName || ''}
        ${senderDetailedAddress || ''}
        ${senderStreet || ''}
        ${senderTownship || ''}`
      }
    },
    {
      label: '目的网点',
      prop: 'dispatchNetworkName'
    },
    {
      label: '收件人电话',
      prop: 'receiverMobilePhone',
      style: { width: '120px' },
      decode: true
    },
    {
      label: '收件地址',
      prop: 'receiverFullAddress',
      style: { width: '20%' },
      formatter({ receiverCountryName, receiverProvinceName, receiverCityName, receiverAreaName, receiverDetailedAddress, receiverStreet, receiverTownship }) {
        return `
          ${receiverCountryName || ''}
          ${receiverProvinceName || ''}
          ${receiverCityName || ''}
          ${receiverAreaName || ''}
          ${receiverDetailedAddress || ''}
          ${receiverStreet || ''}
          ${receiverTownship || ''}`
      }
    },
    {
      label: '操作',
      prop: 'operation',
      slot: true
    }
  ]
}

// 处理记录
export const handle = {
  head: [
    [
      {
        label: '处理机构',
        labelWidth: 70,
        width: 200,
        prop: 'opOrgType',
        formatter({ opOrgType }) {
          const dict = {
            'CP': '系统',
            'HEADQUARTERS': '总部',
            'NETWORK': '网点',
            'AGENT_AREA': '代理区',
            'BPO': '服务商'
          }
          return dict[opOrgType]
        }
      },
      {
        label: '处理时间',
        labelWidth: 70,
        prop: 'createTime'
      }
    ],
    [
      {
        label: '处理人',
        labelWidth: 70,
        width: 200,
        prop: 'opName',
        formatter({ opName, opCode }) {
          return `${opName}/${opCode}`
        }
      },
      {
        label: '处理类型',
        labelWidth: 70,
        prop: 'opType',
        formatter({ opType }) {
          const dict = {
            'TASK_INIT': '任务生成',
            'CP_RECHECKED': '首次质检',
            'RECHECK_ASSIGN': '人工复检分配',
            'RECHECKED': '提交人工复检',
            'APPEAL': '发起申诉',
            'APPEAL_RECHECK_ASSIGN': '申诉复检分配',
            'APPEAL_RECHECKED': '提交申诉复检',
            'CLOSE': '完结'
          }
          return dict[opType]
        }
      }
    ]
    // [
    //   {
    //     label: '指定受理网点',
    //     labelWidth: 90,
    //     width: 200,
    //     prop: 'acceptNetworkName',
    //     formatter: ({ acceptNetworkName }) => acceptNetworkName || '--'
    //   },
    //   {
    //     label: '责任网点',
    //     labelWidth: 70,
    //     prop: 'dutyNetworkName',
    //     formatter: ({ dutyNetworkName }) => dutyNetworkName || '--'
    //   }
    // ]
  ],
  column: [
    // {
    //   label: '催单原因',
    //   labelWidth: 80,
    //   prop: 'reminderReason',
    //   hide({ reminderReason }) {
    //     return reminderReason
    //   },
    //   formatter({ reminderReason }) {
    //     const item = DICT.urgeReason.find(o => o.value === reminderReason) || {}
    //     return item.label
    //   }
    // },
    {
      label: '描述',
      labelWidth: 80,
      prop: 'remark',
      formatter({ remark }) {
        const remarkDeal = remark
        // remarkDeal.startsWith('【') && (remarkDeal = remarkDeal.substr(1))
        // remarkDeal.endsWith('】') && (remarkDeal = remarkDeal.substr(0, remarkDeal.length - 1))
        return remarkDeal
      }
    },
    {
      label: '',
      labelWidth: 80,
      img: true,
      prop: 'files',
      formatter({ files }) {
        files = files || []
        return imgRegularFn(files)
      }
    }
  ]
}

// 物流轨迹
export const trail = {
  showNetInfo: false,
  abnormalTask: false,
  showStopList: false,
  showPackInfo: false,
  width: '660px',
  head: [
    // { label: '序号', style: { width: '50px' }, prop: 'index' },
    { label: '扫描时间', style: { width: '78px' }, prop: 'scanTime', html: true, formatter: ({ scanTime }) => scanTime.replace(/\s/, '<br>'), slotTitle: true },
    { label: '扫描类型', style: { width: '60px' }, prop: 'scanTypeName' },
    { label: '跟踪记录描述', style: { flex: '1' }, prop: 'waybillTrackingContent' },
    {
      label: '扫描网点',
      style: { width: '160px' },
      prop: 'scanNetworkName',
      formatter: ({ scanNetworkName: name, scanNetworkCode: code }) => (name && code ? `${name} | ${code}` : name)
    },
    { label: '图片', prop: 'showImg', width: '80px' }
  ]
}

// 问题记录
export const problem = {
  width: '1800px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    { label: '登记时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '问题件类型', style: { width: '100px' }, prop: 'probleTypeSubjectName' },
    { label: '问题件原因', style: { flex: 1 }, prop: 'probleDescription', slot: true },
    { label: '问题件图片', style: { width: '70px' }, prop: 'urls', slot: true },
    { label: '最新回复内容', style: { flex: 1 }, prop: 'lastReplyContent', slot: true },
    {
      label: '问题件状态',
      style: { width: '70px' },
      prop: 'problePieceStatus',
      formatter({ problePieceStatus }) {
        const dict = ['登记方已登记', '登记方已回复', '接收方已回复', '已转投诉件', '已完结']
        return dict[problePieceStatus - 1] || ''
      }
    },
    { label: '登记人', style: { width: '50px' }, prop: 'createByName' },
    { label: '操作类型', style: { width: '60px' }, prop: 'probleTypeName' },
    { label: '接收网点', style: { width: '70px' }, prop: 'receiveNetworkName' },
    { label: '接收中心', style: { width: '60px' }, prop: 'receiveNetworkParentName' },
    {
      label: '问题件来源 ', style: { width: '70px' }, prop: 'problePieceSource', formatter({ problePieceSource }) {
        const dict = ['JMS系统', '巴枪app', 'PC', '共配', '第三方代派', '百世', '菜鸟机器人', '智兔']
        return dict[problePieceSource - 1]
      }
    }
  ]
}

// 问题记录回复
export const problemMin = {
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    { label: '回复网点', style: { width: '100px' }, prop: 'replyNetworkName' },
    { label: '回复时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '回复人', style: { width: '50px' }, prop: 'createByName' },
    { label: '回复人手机号', style: { width: '75px' }, prop: 'replyPhone' },
    { label: '回复内容', style: { width: '600px' }, prop: 'replyContent', slot: true },
    { label: '回复附件', prop: 'urls', style: { width: '100px' }, slot: true }
  ]
}

// 工单/理赔
export const workOrder = {
  width: '1400px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '工单类型',
      style: { width: '60px' },
      prop: 'workOrderType',
      formatter({ workOrderType }) {
        const dict = ['-', '普通工单', '理赔工单', '平台工单', '问题记录']
        return dict[workOrderType]
      }
    },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '登记时间', style: { width: '70px' }, prop: 'createTime' },
    { label: '来电对象', style: { width: '60px' }, prop: 'customerName' },
    {
      label: '来电对象类型',
      style: { width: '85px' },
      prop: 'customerType',
      toggle: true,
      formatter({ customerType }) {
        const dict = ['寄件人', '收件人', '其他']
        return dict[customerType - 1]
      }
    },
    { label: '来电号码', style: { width: '75px' }, prop: 'customerPhone', toggle: true },
    { label: '一级问题类型', style: { width: '85px' }, prop: 'firstTypeName', toggle: true },
    { label: '二级问题类型', style: { width: '85px' }, prop: 'secondTypeName' },
    {
      label: '工单状态',
      style: { width: '60px' },
      prop: 'status',
      formatter({ status }) {
        const dict = ['待处理', '待分配', '处理中', '已关闭']
        return dict[status]
      }
    },
    { label: '登记人', style: { width: '75px' }, prop: 'createByName', toggle: true },
    { label: '工单登记人', style: { width: '75px' }, prop: 'serviceRegistrantName', toggle: true },
    { label: '问题描述', style: { flex: 1 }, prop: 'problemDescription' },
    { label: '投诉内容', style: { flex: 1 }, prop: 'complaintDesc' }
  ]
}

// 工单/理赔记录回复
export const workOrderMin = {
  head: [
    { label: '处理机构', style: { width: '100px' }, prop: 'operationNetworkName' },
    { label: '处理时间', style: { width: '75px' }, prop: 'operationTime' },
    { label: '处理人', style: { width: '60px' }, prop: 'operatorName' },
    { label: '处理意见', style: { width: '600px' }, prop: 'handlingOpinions' },
    { label: '处理附件', style: { width: '150px' }, prop: 'enclosure', type: 'enclosure' }
  ]
}

// 仲裁
export const arbitration = {
  width: '2100px',
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    { label: '申报网点', style: { width: '100px' }, prop: 'createNetworkName' },
    { label: '申报时间', style: { width: '70px' }, prop: 'createTime' },
    { label: '一级异常类型', prop: 'firstType' },
    { label: '二级异常类型', prop: 'secondType' },
    { label: '异常说明', style: { flex: 1 }, prop: 'exceptionDesc' },
    { label: '责任网点', style: { width: '100px' }, prop: 'responsibilityNetworkName' },
    {
      label: '仲裁状态',
      prop: 'status',
      formatter({ status }) {
        const dict = ['责任方处理中', '已撤销', '待仲裁分配', '仲裁受理中', '仲裁核实中', '仲裁退回', '仲裁裁定完成', '申诉受理中', '申诉核实中', '已结案']
        return dict[status - 1] || ''
      }
    },
    { label: '结案时间', style: { width: '75px' }, prop: 'closingTime' },
    { label: '仲裁处理意见', style: { flex: 1 }, prop: 'arbitrationAdjudicateOpinion' },
    { label: '申诉处理意见', style: { flex: 1 }, prop: 'appealAdjudicateOpinion' }
  ]
}

// 质量
export const quality = {
  width: '1600px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '质量工单状态',
      style: { width: '150px' },
      prop: 'workOrderStatus',
      formatter({ workOrderStatus }) {
        const item = DICT.Q_status.find(o => o.value === workOrderStatus) || {}
        return item.label
      }
    },
    { label: '申报时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '一级类型', prop: 'problemTypeName' },
    { label: '二级类型', prop: 'problemTypeSubjectName' },
    { label: '申报网点', prop: 'applyNetworkName' },
    { label: '奖励金额', prop: 'awardAmount' },
    { label: '申报代理区', prop: 'applyProxyNetworkName' },
    { label: '责任网点', prop: 'responsibleNetworkName' },
    { label: '惩罚金额', prop: 'penaltyAmount' },
    { label: '责任代理区', prop: 'responsibleProxyNetworkName' },
    { label: '问题描述', style: { flex: 1 }, prop: 'problemDescription' },
    { label: '查看图片', style: { width: '70px' }, prop: 'urls', slot: true }
  ]
}

// 质量记录回复
export const qualityMin = {
  head: [
    { label: '操作节点', prop: 'fromNetworkName' },
    { label: '操作人', prop: 'processorName' },
    { label: '联系方式', prop: 'contactInformation' },
    { label: '流向节点', prop: 'toNetworkName' },
    {
      label: '操作类型',
      prop: 'operationType',
      formatter({ operationType }) {
        const item = DICT.Q_operationType.find(o => o.value === operationType) || {}
        return item.label
      }
    },
    { label: '惩罚金额', prop: 'penaltyAmount' },
    { label: '奖励金额', prop: 'awardAmount' },
    { label: '操作时间', style: { width: '150px' }, prop: 'createTime' },
    { label: '处理原因', style: { flex: 1 }, prop: 'processorOpinions' },
    { label: '问题件附件', style: { width: '70px' }, prop: 'urls', slot: true },
    { label: '举证附件', style: { width: '70px' }, prop: 'files', slot: true }
  ]
}

// 无头件查询
export const noHeadless = {
  width: '1000px',
  head: [
    { label: '登记网点', prop: 'scanNetworkName' },
    { label: '认领网点', prop: 'claimNetworkName' },
    { label: '认领单号', style: { width: '130px' }, prop: 'claimWaybillNo' },
    { label: '处理方式', prop: 'dealTypeName' },
    { label: '认领人姓名', prop: 'claimPersonName' },
    { label: '认领人工号', prop: 'claimPersonCode' },
    { label: '认领时间', style: { width: '120px' }, prop: 'createTime' }
  ]
}
// 留言板
export const MessageBoard = {
  // width: '1000px',
  width: '1200px',
  head: [
    { label: '留言时间', style: { width: '140px' }, prop: 'createTime' },
    {
      label: '留言类型', style: { width: '140px' }, prop: 'leaveMessageType',
      formatter({ leaveMessageType }) {
        const item = DICT.leaveMessageType.find(o => o.value === leaveMessageType) || {}
        return item.label
      }
    },
    { label: '二级类型', prop: 'secondTypeName' },
    { label: '发送人', prop: 'createByName' },
    { label: '发送网点', style: { width: '150px' }, prop: 'registerNetworkName' },
    { label: '接收网点', style: { width: '150px' }, prop: 'receiveNetworkName' },
    { label: '留言内容', style: { flex: 1 }, prop: 'replyContent', slot: true },
    { label: '查看图片', style: { width: '70px' }, prop: 'fileUrl', slot: true }
  ]
}
// 录单留言板
export const MessageBoardKFLD = {
  // width: '1000px',
  width: '1200px',
  head: [
    { label: '留言时间', style: { width: '140px' }, prop: 'createTime' },
    {
      label: '留言类型', style: { width: '140px' }, prop: 'leaveMessageType',
      formatter({ leaveMessageType }) {
        const item = DICT.leaveMessageType.find(o => o.value === leaveMessageType) || {}
        return item.label
      }
    },
    { label: '二级类型', prop: 'secondTypeName' },
    { label: '发送人', prop: 'createByName' },
    { label: '发送网点', style: { width: '150px' }, prop: 'registerNetworkName' },
    { label: '接收网点', style: { width: '150px' }, prop: 'receiveNetworkName' },
    { label: '留言内容', style: { flex: 1 }, prop: 'replyContent', slot: true },
    { label: '查看图片', style: { width: '70px' }, prop: 'fileUrl', slot: true }
  ]
}

// 95通话记录
export const PhoneCallLog = {
  head: [
    { label: '序号', style: { width: '50px' }, prop: 'index' },
    {
      label: '话单序列号',
      sortable: false,
      prop: 'sn',
      style: { width: '130px' }
    },
    {
      label: '用户账号ID',
      sortable: false,
      prop: 'staffName'
    },
    {
      label: '通话开始时间',
      sortable: false,
      prop: 'startTime',
      style: { width: '78px' }
    },
    {
      label: '通话结束时间',
      sortable: false,
      prop: 'endTime',
      style: { width: '78px' }
    },
    {
      label: '通话类型',
      prop: 'callType',
      formatter({ callType }) {
        const dict = ['单呼出', '单呼入', '呼入呼出(回溯)']
        return dict[callType] || ''
      }
    },
    {
      label: '通话状态',
      prop: 'connectStatus',
      formatter({ connectStatus }) {
        const dict = ['未接通', '已接通']
        return dict[connectStatus] || ''
      }
    },
    {
      label: '挂机原因',
      prop: 'hangupCause',
      formatter({ hangupCause }) {
        const dict = ['正常挂机', '网络断开', '运营商故障']
        return dict[hangupCause] || ''
      }
    },
    {
      label: '主叫号码',
      sortable: false,
      // slot: true,
      prop: 'callerNum',
      style: { width: '120px' }
    },
    {
      label: '被叫号码',
      sortable: false,
      // slot: true,
      prop: 'calledNum',
      style: { width: '120px' }
    },
    {
      label: '结算通话时长（分钟）',
      sortable: false,
      width: 140,
      prop: 'durationMinutes',
      formatter: (row, value, label, column) => {
        return row.connectStatus === 0 ? 0 : row.durationMinutes
      }
    },
    {
      label: '实际通话时长（秒）',
      sortable: false,
      width: 140,
      prop: 'durationSecondsStr'
    },
    {
      label: '操作',
      sortable: false,
      prop: 'operate',
      style: { width: '60px' }
    }
  ]
}

// 百世物流轨迹
export const immortalTrail = {
  width: '800px',
  head: [
    {
      label: '扫描时间',
      sortable: false,
      prop: 'acceptTime',
      style: { width: '130px' }
    },
    // {
    //   label: '城市',
    //   sortable: false,
    //   prop: 'acceptAddress',
    //   style: { width: '130px' }
    // },
    {
      label: '操作记录',
      sortable: false,
      prop: 'remark',
      style: { width: '478px' }
    },
    {
      label: '扫描类型',
      sortable: false,
      prop: 'scanType',
      style: { width: '78px' }
    }
  ]
}
// 来电记录
export const CallRecords = {
  width: '800px',
  head: [
    // {
    //   label: '会话ID',
    //   sortable: false,
    //   prop: 'sessionId'
    // },
    {
      label: '记录时间',
      sortable: false,
      prop: 'createTime',
      style: { width: '178px' }
    },
    {
      label: '来电号码',
      prop: 'callPhone',
      style: { width: '178px' }
    },
    {
      label: '运单号',
      sortable: false,
      prop: 'waybillNo',
      style: { width: '178px' }
    },
    {
      label: '来电对象',
      sortable: false,
      prop: 'callPerson',
      style: { width: '98px' }
    },
    {
      label: '来电方',
      prop: 'callFrom',
      formatter({ callFrom }) {
        const dict = ['', '寄件人', '收件人', '其他']
        return dict[callFrom] || ''
      }
    },
    {
      label: '进线方式',
      prop: 'callType',
      formatter({ callType }) {
        const dict = ['', '热线电话', '在线客服', '其他']
        return dict[callType] || ''
      }
    },
    {
      label: '接待人',
      prop: 'registrant'
    },
    {
      label: '登记网点',
      prop: 'registrationNetworkName'
    }
  ]
}
// 申诉流水轨迹
export const handleTrail = {
  handleTrail: true, // 处理机构处理人 特殊数据
  datanameFst: 'time',
  datanameSed: 'operatingList',
  commonHead: [
    [
      {
        label: '处理机构',
        labelWidth: 70,
        width: 140,
        prop: 'processOrg'
      },
      {
        label: '处理人',
        labelWidth: 70,
        width: 140,
        prop: 'processName'
      },
      {
        width: 140,
        prop: 'processCode', // 处理人编码
        formatter: ({ processCode }) => {
          return '（' + processCode + '）'
        }
      }
    ]
  ],
  column: [
    [
      {
        label: '流水号',
        labelWidth: 48,
        width: 205,
        prop: 'financeCode'
      },
      {
        width: 60,
        prop: 'costType',
        formatter: ({ costType }) => {
          return costType === 1 ? '奖励金额' : '处罚金额'
        }
      },
      {
        label: '金额',
        labelWidth: 37,
        width: 90,
        prop: 'amount'
      },
      {
        width: 60,
        prop: 'network',
        formatter: ({ costType }) => {
          return costType === 1 ? '奖励网点' : '责任网点'
        }
      },
      {
        width: 210,
        prop: 'networkName'
      },
      {
        width: 40,
        prop: 'pushStatus',
        formatter: ({ pushStatus }) => {
          const pushStatusArr = ['未推送', '成功', '失败']
          return pushStatusArr[pushStatus]
        }
      }
    ]
  ]
}

// 干线规划
export const mainPlanning = {
  width: '1700px',
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    {
      label: '线路名称',
      style: { width: '200px' },
      prop: 'lineName'
    },
    {
      label: '规划发车时间',
      style: { width: '100px' },
      prop: 'planDepartureTime'
    },
    {
      label: '规划到达时间',
      style: { width: '100px' },
      prop: 'planDestinationTime'
    },
    {
      label: '跨越天数',
      style: { width: '60px' },
      prop: 'acrossDays'
    },
    {
      label: '最早散货支线',
      style: { width: '100px' },
      prop: 'firstBulkCargoBranchLine'
    },
    {
      label: '衔接时长',
      style: { width: '60px' },
      formatter: ({ joinDuration }) => {
        return dealTimeout(joinDuration)
      },
      prop: 'joinDuration'
    },
    {
      label: '操作衔接时长',
      style: { width: '100px' },
      prop: 'operateJoinDuration',
      formatter: ({ operateJoinDuration }) => {
        return dealTimeout(operateJoinDuration)
      }
    },
    {
      label: '车型',
      style: { width: '60px' },
      prop: 'vehicleType'
    },
    {
      label: '是否兜底',
      style: { width: '60px' },
      prop: 'isRevealDetail',
      formatter({ isRevealDetail }) {
        const dict = ['', '是', '否']
        return dict[isRevealDetail] || ''
      }
    },
    {
      label: '即发又囤',
      style: { width: '60px' },
      prop: 'sendStore',
      formatter({ sendStore }) {
        const dict = ['', '是', '否']
        return dict[sendStore] || ''
      }
    },
    {
      label: '计费方式',
      style: { width: '60px' },
      prop: 'billingName'
      // formatter({ billing }) {
      //   const dict = ['', '整车计重', '零担计重', '按趟计费']
      //   return dict[billing] || ''
      // }
    },
    {
      label: '生效日期',
      style: { width: '100px' },
      prop: 'effectTime'
    },
    {
      label: '失效日期',
      style: { width: '100px' },
      prop: 'failureTime'
    }
  ]
}
// 邮政工单外层
export const postalOrder = {
  width: '1200px',
  head: [
    { label: '序号', style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '申诉编号',
      style: { width: '140px' },
      prop: 'appealNo'
    },
    { label: '运单号', style: { width: '120px' }, prop: 'waybillNo' },
    { label: '处理状态', style: { width: '70px' }, prop: 'statusStr' },
    { label: '登记时间', style: { width: '130px' }, prop: 'complaintTime' },
    {
      label: '申诉人',
      style: { width: '85px' },
      prop: 'userName'
    },
    { label: '申诉人手机号', style: { width: '100px' }, prop: 'phone' },
    { label: '受理方', style: { width: '85px' }, prop: 'acceptNetworkName' },
    { label: '问题描述', style: { width: '200px' }, prop: 'description' },
    {
      label: '申诉原因',
      style: { width: '60px' },
      prop: 'causeStr'
    }
  ]
}

// 支线规划
export const regionalPlanning = {
  width: '1800px',
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    {
      label: '线路名称',
      style: { width: '200px' },
      prop: 'lineName'
    },
    {
      label: '最晚到车时间',
      style: { width: '100px' },
      prop: 'latestArrivalTime'
    },
    {
      label: '规划发件时间',
      style: { width: '100px' },
      prop: 'planSendTime'
    },
    {
      label: '发件跨天',
      style: { width: '60px' },
      prop: 'sendAcrossDay'
    },
    {
      label: '规划发车时间',
      style: { width: '100px' },
      prop: 'planDepartureTime'
    },
    {
      label: '规划到车时间',
      style: { width: '100px' },
      prop: 'planDestinationTime'
    },
    {
      label: '派件跨天',
      style: { width: '60px' },
      prop: 'deliveryAcrossDay'
    },
    {
      label: '签收截止时间',
      style: { width: '100px' },
      prop: 'signAbortTime'
    },
    {
      label: '对应派仓派件班车',
      style: { width: '120px' },
      prop: 'sendStoreDeliveryShuttleBus'
    },
    {
      label: '最晚入仓时间',
      style: { width: '100px' },
      prop: 'lastWarehousingTime'
    },
    {
      label: '派仓派件结束时间',
      style: { width: '120px' },
      prop: 'sendStoreDeliveryEndTime'
    },
    {
      label: '散货班次',
      style: { width: '60px' },
      prop: 'bulkCargoClasses'
    },
    {
      label: '散货时间',
      style: { width: '60px' },
      prop: 'bulkCargoTime'
    }, {
      label: '生效日期',
      style: { width: '100px' },
      prop: 'effectTime'
    },
    {
      label: '失效日期',
      style: { width: '100px' },
      prop: 'failureTime'
    }
  ]
}
// 邮政工单里层
export const postalOrderMin = {
  head: [
    { label: '处理机构', style: { width: '100px' }, prop: 'processNetworkName' },
    { label: '处理时间', style: { width: '120px' }, prop: 'createTime' },
    { label: '处理人', style: { width: '60px' }, prop: 'processByName' },
    { label: '处理意见', style: { width: '600px' }, prop: 'content' }
  ]
}

// 针对干线支线处理时间
function dealTimeout(val) {
  let time = '00:00'
  if (val) {
    const int = parseInt(val / 60)
    const remainder = val % 60
    const points = remainder >= 10 ? remainder : '0' + remainder
    time = int >= 10 ? int + ':' + points : '0' + int + ':' + points
  }
  if (!val && val !== 0) return '--'
  return time
}

export const cusServeRecord = {
  width: '660px',
  head: [
    {
      label: '录入组别', style: { width: '78px' }, prop: 'recordGroup',
      formatter({ recordGroup }) {
        const dict = ['', '电话组', '在线组']
        return dict[recordGroup] || ''
      }
    },
    { label: '客户进线/来电时间', style: { width: '160px' }, prop: 'createTime' },
    { label: '接待客服名称', style: { width: '160px' }, prop: 'registrant' },
    {
      label: '接待客服所属网点',
      style: { width: '160px' },
      prop: 'registrationNetworkName',
      formatter: ({ registrationNetworkName: name, registrationNetworkCode: code }) => (name && code ? `${name} | ${code}` : name)
    },
    { label: '操作', prop: 'recordOperate', width: '80px' }
  ]
}

// 工单/理赔
export const workOrderForm = {
  // width: '1400px',
  head: [
    { style: { width: '76px' }, prop: 'detailIcon' },
    {
      label: '工单类型',
      style: { width: '60px' },
      prop: 'workOrderType',
      formatter({ workOrderType }) {
        const dict = ['-', '普通工单', '理赔工单', '平台工单', '问题记录']
        return dict[workOrderType]
      }
    },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '登记时间', style: { width: '150px' }, prop: 'createTime' },
    { label: '来电对象', style: { width: '60px' }, prop: 'customerName' },
    {
      label: '来电对象类型',
      style: { width: '85px' },
      prop: 'customerType',
      toggle: true,
      formatter({ customerType }) {
        const dict = ['寄件人', '收件人', '其他']
        return dict[customerType - 1]
      }
    },
    { label: '来电号码', style: { width: '75px' }, prop: 'customerPhone', toggle: true },
    { label: '一级问题类型', style: { width: '85px' }, prop: 'firstTypeName', toggle: true },
    { label: '二级问题类型', style: { width: '85px' }, prop: 'secondTypeName' },
    {
      label: '工单状态',
      style: { width: '60px' },
      prop: 'status',
      formatter({ status }) {
        const dict = ['待处理', '待分配', '处理中', '已关闭']
        return dict[status]
      }
    },
    { label: '登记人', style: { width: '75px' }, prop: 'createByName', toggle: true },
    { label: '工单登记人', style: { width: '75px' }, prop: 'serviceRegistrantName', toggle: true },
    { label: '问题描述', style: { width: '150px' }, prop: 'problemDescription' },
    { label: '投诉内容', style: { width: '150px' }, prop: 'complaintDesc' }
  ]
}

// 工单/理赔记录回复
export const workOrderMinForm = {
  width: '1300px',
  head: [
    { label: '处理机构', style: { width: '120px' }, prop: 'operationNetworkName' },
    { label: '处理时间', style: { width: '180px' }, prop: 'operationTime' },
    { label: '处理人', style: { width: '90px' }, prop: 'operatorName' },
    { label: '处理意见', style: { width: '300px' }, prop: 'handlingOpinions' },
    { label: '处理附件', style: { width: '100px' }, prop: 'enclosure', type: 'enclosure' }
  ]
}
